import { ActionStatus } from '../../../common/constants/action-status';
import { createSlice } from '@reduxjs/toolkit';
import { defaultApiState } from '../../../common/constants/api-constants';
import { ReturnState } from '../interfaces/return-states.interface';
import { returnOrder } from '../thunks/order-return.thunk';

/*----- CREATE INITIAL STATE ------*/

export const returnStateInitialState: ReturnState = {
  orderReturn: defaultApiState
};

/*----- CREATE STORE SLICE ------*/
export const returnSlice = createSlice({
  name: 'return',
  initialState: returnStateInitialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(returnOrder.pending, (state) => {
        state.orderReturn.status = ActionStatus.loading;
      })
      .addCase(returnOrder.fulfilled, (state, action) => {
        state.orderReturn.status = ActionStatus.succeeded;
        state.orderReturn.data = action.payload;
      })
      .addCase(returnOrder.rejected, (state, action) => {
        state.orderReturn.status = ActionStatus.failed;
        state.orderReturn.error = action.error.message || '';
      });
  },
});

/*----- CREATE REDUCER ------*/
export const returnReducer = returnSlice.reducer;
